import { render, staticRenderFns } from "./DiscountPromoNotificationBox.vue?vue&type=template&id=4e4d283f&scoped=true&"
import script from "./DiscountPromoNotificationBox.vue?vue&type=script&lang=js&"
export * from "./DiscountPromoNotificationBox.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPromoNotificationBox.vue?vue&type=style&index=0&id=4e4d283f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4d283f",
  null
  
)

export default component.exports